import { module }from 'stereomodularjs';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: 'overlayClose'
        }
    }

    init(){
        document.addEventListener('keydown', (event) => {
            if (document.documentElement.classList.contains('is-overlay-active') && event.key === 'Escape') {
                this.overlayClose();
            }
        });
    }

    overlayClose() {
        let thisEl = this.el;
        // toggleChildsTabindex(thisEl, '-1');

        // Remove state active to hide overlay
        classRemove(document.querySelector('.is-overlay-active'), 'is-overlay-active');

        // Set proper states to container
        let overlayPanelContainer = document.querySelector('.js-overlay-content-container');
        overlayPanelContainer.setAttribute('aria-hidden', 'true');
        overlayPanelContainer.removeAttribute('open');

        // Set proper states to buttons
        let closeButtons = document.querySelectorAll('.js-overlay__close button')
        closeButtons.forEach(button => {
            // toggleChildsTabindex(button, '-1');
            button.setAttribute('aria-hidden', 'true');
            button.setAttribute('disabled', true);
        })

        // Set all focusable elements to disabled state
        let focusElsListDisabled = 'a[href]:not([disabled]), button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled])';
        let focusElsDisabled = overlayPanelContainer.querySelectorAll(focusElsListDisabled);
        focusElsDisabled.forEach(focusEl => {
            focusEl.setAttribute('disabled', true);
        });
        
        let videoPlayerWrapper = document.querySelector('.js-overlay-video-player__wrapper');
        videoPlayerWrapper.innerHTML = "";

        //this.call('stop', true, 'VideoPlayer');
        // Remove content after animation
        // let overlayVideo = document.querySelector('.js-overlay-video .o-video-player');
        // if (overlayVideo != null){
        //     this.call('pause', null, 'VideoPlayer');
        //     // overlayVideo.innerHtml = '<video controls crossorigin playsinline class="js-plyr-wrapper"></video>';
        // }

        // Focus back to trigger element
        let returnFocusEl = document.querySelector('.js-overlay-focus-back');
        if (returnFocusEl) {
            console.log(returnFocusEl + ' set focus');
            document.activeElement.blur();
            returnFocusEl.focus();
            classRemove(returnFocusEl, 'js-overlay-focus-back');
        }

        setTimeout(function () {
            classRemove(document.querySelector('.c-overlay-content__item.is-active'), 'is-active');
        }, 400)
    }
}
